
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 1768","fill":"currentColor","d":"M0 0h17.35v17.469H0z"}})])]),_c('g',{attrs:{"data-name":"Group 3480","transform":"translate(3 3)","clip-path":"url(#a)","fill":"currentColor"}},[_c('path',{attrs:{"data-name":"Path 2286","d":"M13.081 17.47H2.1a2.1 2.1 0 01-2.1-2.1V4.389a2.1 2.1 0 012.1-2.1h5.49a.692.692 0 110 1.383H2.1a.716.716 0 00-.716.715v10.985a.716.716 0 00.716.715h10.981a.716.716 0 00.715-.715V9.88a.692.692 0 111.383 0v5.492a2.1 2.1 0 01-2.1 2.1"}}),_c('path',{attrs:{"data-name":"Path 2287","d":"M6.14 11.9a.691.691 0 01-.68-.817l.489-2.648a.692.692 0 01.191-.363L13.777.438a1.5 1.5 0 012.117 0l1.019 1.019a1.5 1.5 0 010 2.117l-7.636 7.635a.684.684 0 01-.363.191l-2.648.49a.693.693 0 01-.126.012m1.13-3l-.268 1.448 1.448-.268L15.935 2.6a.114.114 0 000-.162l-1.018-1.023a.117.117 0 00-.162 0z"}}),_c('path',{attrs:{"data-name":"Path 2288","d":"M15.49 4.709a.689.689 0 01-.489-.2l-2.158-2.161a.691.691 0 11.977-.978l2.164 2.158a.691.691 0 01-.489 1.18"}})])])
          )
        }
      }
    